import { Directive, ElementRef, Input, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { MatDatetimepickerComponent } from '@mat-datetimepicker/core';
import { Subscription } from 'rxjs';

@Directive({
	selector: '[appDatetimepickerPosition]'
})
export class DatetimepickerPositionDirective implements AfterViewInit, OnDestroy {
	@Input('matDatetimepickerComp') datetimepicker: MatDatetimepickerComponent<Date>;
	private subscription: Subscription;
	private activeElement: HTMLElement | null = null;

	constructor(private elementRef: ElementRef) { }

	ngAfterViewInit() {
		if (this.datetimepicker) {
			this.subscription = this.datetimepicker.openedStream.subscribe(() => {
				// #43017 elementRef reference is chaged on scroll to another instance, so we store initial reference to work with
				this.activeElement = this.elementRef.nativeElement;
				this.hideOverlay();
				setTimeout(() => {
					this.setPosition();
				}, 0);
			});

			this.subscription.add(
				this.datetimepicker.closedStream.subscribe(() => {
					this.activeElement = null;
				})
			);
		}
	}

	@HostListener('window:scroll', ['$event'])
	private onWindowScroll(event: Event) {
		if (this.activeElement) {
			this.setPosition();
		}
	}

	@HostListener('window:resize', ['$event'])
	private onResize(event: Event) {
		if (this.activeElement) {
			// Adding a timeout because resizing the window and timing of setposition kept messing with each other
			// timeout = 50 seemed to do the trick.
			// 10 was still too fast.
			setTimeout(() => {
				this.setPosition();
			}, 50);
		}
	}

	private hideOverlay() {
		const overlayPane: HTMLDivElement = document.querySelector('.cdk-overlay-pane.mat-datetimepicker-popup');
		if (overlayPane) {
			overlayPane.style.visibility = 'hidden';
		}
	}

	private setPosition() {
		if (!this.activeElement) return;

		const rect = this.activeElement.getBoundingClientRect();
		const overlayPane: HTMLDivElement = document.querySelector('.cdk-overlay-pane.mat-datetimepicker-popup');

		if (overlayPane) {
			const overlayRect = overlayPane.getBoundingClientRect();
			const viewportWidth = window.innerWidth;
			const viewportHeight = window.innerHeight;

			let top = rect.bottom;
			let left = rect.left;

			if (top + overlayRect.height > viewportHeight) {
				top = rect.top - overlayRect.height;
			}

			if (left + overlayRect.width > viewportWidth) {
				left = viewportWidth - overlayRect.width;
			}

			top = Math.max(0, top);
			left = Math.max(0, left);

			overlayPane.setAttribute('style', `top: ${top}px !important; left: ${left}px !important;`);
			overlayPane.style.visibility = 'visible';
		}
	}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
